
import React from 'react'
import { Icon } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import { useSelector , useDispatch} from 'react-redux';
import {  SetShowSearchBox } from "../../../../redux/actions/mainActions"
import SearchLocation from '../SearchLocation/SearchLocation';

import "./SearchBox.css"

const SearchBox = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const showSearchBox = useSelector((state) => state.main.showSearchBox)




    return !showSearchBox ? null :<div className="position-fixed z-index-2200 top-0 right-0 left-0 bg-white p-1 h-100vh w-100">
        <Icon  size="big" name="angle left" onClick={()=>dispatch(SetShowSearchBox(false))}></Icon>
        <SearchLocation />
    </div>


}
export default SearchBox